module.exports = "<section>\r\n\t<div ng-repeat=\"banner in banners\">\r\n\t\t<div ng-if=\"banner.BannerType == bannerType.image\">\r\n\t\t\t<img loading=\"lazy\" width=\"100%\" ng-srcset=\"{{banner.ImageSmall}} 750w, {{banner.ImageMedium}} 970w, {{banner.ImageLarge}} 1170w, {{banner.ImageXLarge}} 1200w\"/>\r\n\t\t</div>\r\n\t</div>\r\n</section>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/banners/banners-template.html
 ** module id = 841
 ** module chunks = 2
 **/